import lazyPage from "../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Nav/Notifications/Notifications.tsx",
    () => import("./Notifications"),
);
